import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `kpi_value` component.
 * Keep in sync with KpiValueProps and KpiValues in src/ui/uiConfig/components/KpiValue/KpiValue.tsx
 */
export const kpiValuePropDocs: ComponentDocMap = {
  items: {
    description: 'Array of KPI entries to display. Each item is linked to a dataset via data_id === return_id.',
    type: 'KpiValues[]',
    example:
      '[{ title: "__Total cost", data_id: "total_cost", color: "$color-pps", decimals: 2, unit: "", data_type: "cost" }]',
  },
  'items[].ignore_zoom': {
    description: 'If true, this item is not affected by zoom/filter range.',
    type: 'boolean',
  },
  'items[].bold_title': {
    description: 'Renders item title with bold font weight.',
    type: 'boolean',
  },
  'items[].show_only_in_export': {
    description: 'Includes item in exports only, not in visible UI.',
    type: 'boolean',
  },
  'items[].style': {
    description:
      'Overrides the component-level style for this specific item. "bar" renders a proportional bar, "pie" and "pie_percentage" render small inline pie charts.',
    type: '"bar" | "value" | "pie" | "pie_percentage"',
    example: '"bar"',
  },
  'items[].no_data_icon': {
    description: 'Font Awesome icon class shown when the value is unavailable.',
    type: 'string',
    example: '"fal fa-question-circle"',
  },
  'items[].do_not_show_item': {
    description: 'Hides this item from the rendered output (but the dataset is still fetched).',
    type: 'boolean',
    example: 'true',
  },
  style: {
    description: 'Default rendering style for all items. Can be overridden per item.',
    type: '"bar" | "value" | "pie"',
    example: '"value"',
  },
  title: {
    description: 'Optional heading shown above all KPI values.',
    type: 'string',
    example: '"__Follow-up KPIs"',
  },
  position: {
    description: 'Horizontal alignment of the KPI values within the container.',
    type: '"center" | "left" | "evenly"',
    example: '"center"',
  },
  show_date_range: {
    description: 'Shows the current dataset time range below the KPI values.',
    type: 'boolean',
    example: 'true',
  },
  paddingLeft: {
    description: 'Adds left padding to KPI container.',
    type: 'boolean',
  },
  applyAggregateOptions: {
    description: 'Aggregation options forwarded to dataset aggregation logic.',
    type: 'Record<string, unknown>',
  },
}
